import React, {useState} from 'react';
import Input from "../Common/Input";
import Button from "../Common/Button";
import {VARIANT} from "../../constants";
import '../AccountSetting/style.css';
import IMG from "../../constants/image";
import {changePasswordProfile, merchantConfirmOTP, merchantRegister} from "../../network/api";
import popupStore from "../../store/popupStore";
import OTPInput from "../Common/Input/OTPInput";
import CountDown from "../Common/Button/CountDown";
import merchantStore from "../../store/merchantStore";
import {ERROR_CODE} from "../../constants/error";
import {scrollToTop} from "../../utils";

let confirmId = '';

const ChangePasswordForm = ({setIsChangePassword}) => {
    const {setPopup} = popupStore() || {};
    const {merchantProfile} = merchantStore() || {};
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [errorOldPass, setErrorOldPass] = useState('');

    const {phone_number} = merchantProfile || {};

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validatePassword()) return;
        const res = await changePasswordProfile({oldPassword: currentPassword, newPassword})
        if (res?.success && res?.data?.data?.confirmId) {
            setError('');
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            confirmId = res?.data?.data?.confirmId;
            setPopup({
                isOpen: true,
                data: {
                    customContent: renderOtpChangePassword,
                }
            });
        } else if (res?.data?.code === ERROR_CODE["AUTH-002"] || res?.data?.code === ERROR_CODE["AUTH-019"]) {
            setErrorOldPass('Mật khẩu hiện tại không đúng');
            scrollToTop();
        }
    };

    const validatePassword = () => {
        let err = ''
        if (newPassword !== confirmPassword) {
            err = 'Mật khẩu mới và xác nhận mật khẩu không khớp';
        } else if (newPassword.length < 6 || confirmPassword.length < 6) {
            err = 'Mật khẩu phải có ít nhất 6 ký tự';
        }
        setError(err);
        return err
    }

    const handleResend = async () => {
        const res = await merchantRegister({phoneNumber: phone_number});
        if (res?.success && res?.data?.data?.confirmId) {
            confirmId = res?.data?.data?.confirmId;
        }
    };

    const handleSubmitOTP = async (otp) => {
        const data = await merchantConfirmOTP({confirmId, otp});
        if (data?.success) {
            setPopup({
                isOpen: true,
                data: {
                    title: 'Bạn đã đổi mật khẩu thành công',
                    image: IMG.popupUpdateStatus,
                    accept: {
                        label: 'Đồng ý',
                        action: () => {
                            setIsChangePassword && setIsChangePassword(false);
                            setPopup({})
                        }
                    }
                }
            });
        }
    }
    console.log({error})

    const renderOtpChangePassword = () => {
        return (
            <form className='flex flex-col w-[400px] justify-center items-center text-center gap-5' action="">
                <h2 className='text-sm font-bold'>Nhập mã xác thực (OTP)</h2>
                <p
                    className='text-xs text-[#9E9E9E]'>{`Mã xác thực được gửi đến số điện thoại ${phone_number}. Vui lòng kiểm tra tin nhắn và nhập mã xác thực`}</p>
                <OTPInput handleSubmitOTP={handleSubmitOTP}/>
                <p className='w-[250px] text-sm'>Mã xác thực có hiệu lực trong 2 phút</p>
                <CountDown count={25} onClick={handleResend}/>
            </form>
        );
    }

    return (
        <form className="flex flex-col gap-5 justify-center pb-[100px]" onSubmit={handleSubmit}>
            <div className="acc-section">
                <div className='w-80 flex flex-col gap-5 text-sm'>
                    <Input
                        required
                        title="Mật khẩu hiện tại"
                        type='password'
                        autoComplete="new-password"
                        className='w-full h-[44px]'
                        iconR={IMG.icon.eyeBlack}
                        setError={setErrorOldPass}
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        error={errorOldPass}
                        placeholder='Mật khẩu hiện tại'
                    />

                    <Input
                        required
                        title="Mật khẩu mới"
                        type='password'
                        autoComplete="new-password"
                        className='w-full h-[44px]'
                        iconR={IMG.icon.eyeBlack}
                        value={newPassword}
                        setError={setError}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder='Mật khẩu mới'
                    />

                    <Input
                        required
                        title="Xác nhận lại mật khẩu"
                        type='password'
                        className='w-full h-[44px]'
                        autoComplete="new-password"
                        iconR={IMG.icon.eyeBlack}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        error={error}
                        setError={setError}
                        placeholder='Xác nhận lại mật khẩu'
                    />

                    <div className='w-full'>
                        <Button className='' variant={VARIANT.PRIMARY} type="submit" onClick={handleSubmit}>
                            Lưu thay đổi
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ChangePasswordForm;
